module.exports = __webpack_public_path__ + "fonts/2f837f594af7c8bc353011e891cfef94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/file_pdf_green.svg
// module id = 2011
// module chunks = 0